import type { ISparePartService } from './ISparePartService';
import type { PagedResponse } from '../dto/PagedResponse';
import type { StockLevel } from '../dto/StockLevel.dto';
import type { SparePart } from '../dto/SparePart.dto';
import type { CreateSparePartRequest } from '../dto/CreateSparePartRequest';
import type { UpdateSparePartRequest } from '../dto/UpdateSparePartRequest';
import { ListParams } from '../http/ListParams';
import { QueryBuilder } from '../http/QueryBuilder';
import { JsonRequestBody } from '../http/JsonRequestBody';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';

const BASE = '/api/warehouse/spare-part';

export class SparePartService implements ISparePartService {
    async list(params?: ListParams): Promise<PagedResponse<SparePart>> {
        return fetchWithAuth(
            `${BASE}${QueryBuilder.from(params).build()}`,
            { method: 'GET' }
        );
    }

    async get(externalId: string): Promise<SparePart> {
        return fetchWithAuth(`${BASE}/${externalId}`, { method: 'GET' });
    }

    async create(payload: CreateSparePartRequest): Promise<SparePart> {
        return fetchWithAuth(BASE, { method: 'POST', ...JsonRequestBody.from(payload) });
    }

    async update(externalId: string, payload: UpdateSparePartRequest): Promise<SparePart> {
        return fetchWithAuth(`${BASE}/${externalId}`, { method: 'PATCH', ...JsonRequestBody.from(payload) });
    }

    async updateStatus(externalId: string, status: string): Promise<SparePart> {
        return fetchWithAuth(`${BASE}/${externalId}/status`, { method: 'PATCH', ...JsonRequestBody.from({ status }) });
    }

    async getStock(externalId: string): Promise<StockLevel[]> {
        return fetchWithAuth(`${BASE}/${externalId}/stock`, { method: 'GET' });
    }
}